export default __webpack_public_path__ + "static/media/meat.1df7db9e.svg";